export enum TeamsRing {
  general = 'general',
  general_gcc = 'general_gcc',
  ring0 = 'ring0',
  ring0_s = 'ring0_s',
  ring1 = 'ring1',
  ring1_5 = 'ring1_5',
  ring1_6 = 'ring1_6',
  ring2 = 'ring2',
  ring3 = 'ring3',
  ring3_6 = 'ring3_6',
  ring3_9 = 'ring3_9'
}